import React from 'react';
import PropTypes from 'prop-types';
import { Link, graphql } from 'gatsby';
import Head from '@repo/ui-components/Head';
import * as Styled from '@components/utils/HomePageCategories';

const HomePage = ({ data }) => {
  const categories = data?.allSanitySupportCategory?.nodes ?? [];

  return (
    <>
      <Head
        title="PetSafe® Support | Dog Fences | Feeders | Fountains | Collars | Cat Litter Boxes | Dog Doors | Cat Doors"
        description="PetSafe® Brand is the world's leader in containment, training, and lifestyle solutions to give pet owners more great moments with their pets. Get the help for all of your PetSafe products in one place or connect with a PetSafe product expert."
        linkTags={[
          <link
            key="canonical"
            rel="canonical"
            href="https://www.support.petsafe.net/"
          />,
        ]}
      />
      <Styled.Categories>
        {categories.map(c => (
          <Link
            key={c.title}
            className="categoryLink"
            to={`/categories/${c.slug.current}`}
          >
            <Styled.CategoryItem>
              <div className="categoryTitle">{c.title}</div>
              <Styled.CategoryImage
                image={c.image?.asset?.gatsbyImage}
                loading="eager"
                alt={`${c.image?.asset?.altText}`}
              />
            </Styled.CategoryItem>
          </Link>
        ))}
      </Styled.Categories>
    </>
  );
};

export const query = graphql`
  query PetSafeSupportCategoriesHomeQuery {
    allSanitySupportCategory(filter: { siteIdentifier: { eq: "petsafe" } }) {
      nodes {
        SEOMetadata {
          canonicalUrl
          noFollow
          description
          noIndex
          title
        }
        image {
          asset {
            altText
            assetId
            description
            filesize
            url
            gatsbyImage(width: 307)
          }
        }
        siteIdentifier
        slug {
          current
        }
        title
      }
    }
  }
`;

HomePage.propTypes = {
  data: PropTypes.shape({
    allSanitySupportCategory: PropTypes.shape({
      nodes: PropTypes.shape({
        SEOMetadata: PropTypes.shape({
          canonicalUrl: PropTypes.string,
          noFollow: PropTypes.bool,
          description: PropTypes.string,
          noIndex: PropTypes.bool,
          title: PropTypes.string,
        }),
        image: PropTypes.shape({
          asset: PropTypes.shape({
            altText: PropTypes.string,
            assetId: PropTypes.string,
            description: PropTypes.string,
            filesize: PropTypes.number,
            url: PropTypes.string,
          }),
        }),
        siteIdentifier: PropTypes.string,
        slug: PropTypes.shape({
          current: PropTypes.string,
        }),
        title: PropTypes.string,
      }),
    }),
  }),
};

export default HomePage;
